import { render, staticRenderFns } from "./AddSerialNumber.vue?vue&type=template&id=f55ba7fc&"
import script from "./AddSerialNumber.vue?vue&type=script&lang=js&"
export * from "./AddSerialNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports